<abp-page [title]="'Inventory::AssetModels' | abpLocalization">
  <abp-page-toolbar-container class="col">
    <div class="text-lg-end pt-2">
      <button
        *abpPermission="'Inventory.AssetModels.Create'"
        class="btn btn-primary btn-sm"
        type="button"
        (click)="create()"
      >
        <i class="fa fa-plus me-1" aria-hidden="true"></i>
        {{ 'Inventory::NewAssetModel' | abpLocalization }}
      </button>
    </div>
  </abp-page-toolbar-container>

  <abp-advanced-entity-filters localizationSourceName="Inventory" [list]="list">
    <abp-advanced-entity-filters-form>
      <form #filterForm (keyup.enter)="list.get()">
        <div class="row">
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="nameFilter">
                {{ 'Inventory::Name' | abpLocalization }}
              </label>

              <input
                id="nameFilter"
                class="form-control"
                [(ngModel)]="filters.name"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="descriptionFilter">
                {{ 'Inventory::Description' | abpLocalization }}
              </label>

              <input
                id="descriptionFilter"
                class="form-control"
                [(ngModel)]="filters.description"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="codeFilter">
                {{ 'Inventory::Code' | abpLocalization }}
              </label>

              <input
                id="codeFilter"
                class="form-control"
                [(ngModel)]="filters.code"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="imageFilter">
                {{ 'Inventory::Image' | abpLocalization }}
              </label>

              <input
                id="imageFilter"
                class="form-control"
                [(ngModel)]="filters.image"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="rpaTypeFilter">
                  {{ 'Inventory::RPAType' | abpLocalization }}
              </label>

              <select
                name="rpaType"
                id="rpaTypeFilter"
                class="form-select form-control"
                [(ngModel)]="filters.rpaType"
                [ngModelOptions]="{ standalone: true }"
                (change)="list.get()"
              >
                <option [ngValue]=""></option>
                <option [ngValue]="true">{{ 'AbpUi::Yes' | abpLocalization }}</option>
                <option [ngValue]="false">{{ 'AbpUi::No' | abpLocalization }}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="legalDocumentIdFilter">
                {{ 'Inventory::LegalDocument' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="legalDocumentIdFilter"
                displayNameProp="description"
                lookupNameProp="displayName"
                [getFn]="service.getLegalDocumentLookup"
                [(ngModel)]="filters.legalDocumentId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="maintenanceCategoryIdFilter">
                {{ 'Inventory::MaintenanceCategory' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="maintenanceCategoryIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getMaintenanceCategoryLookup"
                [(ngModel)]="filters.maintenanceCategoryId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>

          <div class="col-12 col-sm-auto align-self-end mb-3">
            <div class="row">
              <div class="col-6 col-sm-auto d-grid">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="clearFilters()"
                >
                  <span>{{ 'AbpUi::Clear' | abpLocalization }}</span>
                </button>
              </div>
              <div class="col-6 col-sm-auto d-grid">
                <button type="button" class="btn btn-primary" (click)="list.get()">
                  <span>{{ 'AbpUi::Refresh' | abpLocalization }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </abp-advanced-entity-filters-form>
  </abp-advanced-entity-filters>

  <div class="card">
    <div class="card-body">
      <ngx-datatable [rows]="data.items" [count]="data.totalCount" [list]="list" default>
        <ngx-datatable-column
          [name]="'AbpUi::Actions' | abpLocalization"
          [maxWidth]="150"
          [width]="150"
          [sortable]="false"
        >
          <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
            <div ngbDropdown container="body" class="d-inline-block">
              <button
                class="btn btn-primary btn-sm dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                ngbDropdownToggle
              >
                <i class="fa fa-cog me-1" aria-hidden="true"></i>
                {{ 'AbpUi::Actions' | abpLocalization }}
              </button>

              <div ngbDropdownMenu>
                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.AssetModels.Edit'"
                  (click)="update(row)"
                >
                  {{ 'AbpUi::Edit' | abpLocalization }}
                </button>

                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.AssetModels.Delete'"
                  (click)="delete(row)"
                >
                  {{ 'AbpUi::Delete' | abpLocalization }}
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Name' | abpLocalization }}" prop="assetModel.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetModel.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Description' | abpLocalization }}" prop="assetModel.description">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetModel.description }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Code' | abpLocalization }}" prop="assetModel.code">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetModel.code }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Image' | abpLocalization }}" prop="assetModel.image">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetModel.image }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::RPAType' | abpLocalization }}" prop="assetModel.rpaType">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <ng-template [ngIf]="row.assetModel.rpaType" [ngIfThen]="yes" [ngIfElse]="no"></ng-template>

            <ng-template #yes>
              <div class="text-center text-success">
                <span [title]="'AbpUi::Yes' | abpLocalization">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </span>
              </div>
            </ng-template>

            <ng-template #no>
              <div class="text-center text-danger">
                <span [title]="'AbpUi::No' | abpLocalization">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </span>
              </div>
            </ng-template>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::LegalDocument' | abpLocalization }}" prop="legalDocument.description">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.legalDocument?.description }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::MaintenanceCategory' | abpLocalization }}" prop="maintenanceCategory.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.maintenanceCategory?.name }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</abp-page>

<abp-modal [busy]="isModalBusy" [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h3>
      {{ (selected ? 'AbpUi::Edit' : 'Inventory::NewAssetModel') | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="form" (ngSubmit)="submitForm()" validateOnSubmit>
      <div class="mt-2 fade-in-top">
        <div class="mb-3">
          <label class="form-label" for="asset-model-name">
            {{ 'Inventory::Name' | abpLocalization }} *
          </label>

          <input
            id="asset-model-name"
            formControlName="name"
            class="form-control"
            autofocus
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-model-description">
            {{ 'Inventory::Description' | abpLocalization }} 
          </label>

          <input
            id="asset-model-description"
            formControlName="description"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-model-code">
            {{ 'Inventory::Code' | abpLocalization }} 
          </label>

          <input
            id="asset-model-code"
            formControlName="code"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-model-image">
            {{ 'Inventory::Image' | abpLocalization }} 
          </label>

          <input
            id="asset-model-image"
            formControlName="image"
            class="form-control"
          />
        </div>
        <div class="form-check mb-3">
          <input
            type="checkbox"
            id="asset-model-rpatype"
            formControlName="rpaType"
            class="form-check-input"
          />

          <label
            for="asset-model-rpatype"
            class="form-check-label"
          >
              {{ 'Inventory::RPAType' | abpLocalization }} 
          </label>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-model-legal-document-id">
            {{ 'Inventory::LegalDocument' | abpLocalization }} 
          </label>
          <abp-lookup-input
            cid="asset-model-legal-document-id"
            formControlName="legalDocumentId"
            displayNameProp="description"
            lookupNameProp="displayName"
            [getFn]="service.getLegalDocumentLookup"
            [editingData]="selected?.legalDocument"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-model-maintenance-category-id">
            {{ 'Inventory::MaintenanceCategory' | abpLocalization }} 
          </label>
          <abp-lookup-input
            cid="asset-model-maintenance-category-id"
            formControlName="maintenanceCategoryId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getMaintenanceCategoryLookup"
            [editingData]="selected?.maintenanceCategory"
          ></abp-lookup-input>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>

    <abp-button iconClass="fa fa-check" (click)="submitForm()" [disabled]="form?.invalid">
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </ng-template>
</abp-modal>
